const containers = document.getElementsByClassName('password-container');

for (const container of containers) {
    const input = container.getElementsByClassName('password-input')[0];
    const hideIcon = container.getElementsByClassName('icon--hide')[0];
    const showIcon = container.getElementsByClassName('icon--show')[0];
    hideIcon.addEventListener('click', function () {
        input.setAttribute('type', 'password');
        hideIcon.style.display = 'none';
        showIcon.style.display = 'block';
    });
    showIcon.addEventListener('click', function () {
        input.setAttribute('type', 'text');
        hideIcon.style.display = 'block';
        showIcon.style.display = 'none';
    });
}
